let measureCtx: CanvasRenderingContext2D | null | undefined;

// Rough fallback (avg glyph width) for environments without a DOM canvas (e.g. SSR/tests).
const FALLBACK_CHAR_WIDTH = 7;

export const measureTextWidth = (text: string, font: string): number => {
  if (typeof document === 'undefined') return text.length * FALLBACK_CHAR_WIDTH;
  if (measureCtx === undefined) {
    measureCtx = document.createElement('canvas').getContext('2d');
  }
  if (!measureCtx) return text.length * FALLBACK_CHAR_WIDTH;
  measureCtx.font = font;
  return measureCtx.measureText(text).width;
};
